import React, { useState, useEffect } from 'react';
import MainHeader from '../Components/Header/MainHeader';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { AiOutlineGift, AiOutlineStar, AiOutlineShoppingCart } from 'react-icons/ai';
import { MdLoyalty } from 'react-icons/md';
import styles from './Home.module.css';
import ResponsiveBanner from '../Components/Home/ResponsiveBanner';
import { BASE_URL_API } from '../References/URLs';
import { Link, useParams } from 'react-router';
import AboutRewardPoints from '../Components/Home/AboutRewardPoints';

const Home = () => {
    const { storeKey } = useParams()
    const [loading, setLoading] = useState(true);
    const [featuredProducts, setFeaturedProducts] = useState([])

    useEffect(() => {
        getFeaturedProducts()
    }, []);


    const getFeaturedProducts = async () => {
        setLoading(true)
        const getFeaturedProductsResponse = await fetch(BASE_URL_API + "getFeaturedProducts",
            {
                method: "POST",
                body: JSON.stringify({
                    storeKey: storeKey
                })
            });

        if (!getFeaturedProductsResponse.ok) {
            console.log('Something went wrong : Server Error')
        } else {
            const getFeaturedProductsRespo = await getFeaturedProductsResponse.json()
            if (getFeaturedProductsRespo.status === "success") {
                setFeaturedProducts(getFeaturedProductsRespo?.response)
            } else {
                if (getFeaturedProductsRespo.status === "failed") {
                    setFeaturedProducts([])
                }
            }
            console.log(getFeaturedProductsRespo)
        }
        setLoading(false)
    }

    return (
        <div className={styles.homeWrapper}>
            <MainHeader />

            {/* Banner Section */}
            <ResponsiveBanner />



            {/* Featured Products Slider */}
            <section className={styles.sliderSection}>
                <h2>Featured Products</h2>
                <div className={styles.sliderContainer}>
                    {loading
                        ? [...Array(5)].map((_, index) => <Skeleton key={index} height={280} width={250} />)
                        : featuredProducts?.map((item, index) => (
                            <Link to={`/${storeKey}/shop`} key={index} className={styles.productCard}>
                                <div className={styles.earnPoints} >
                                    <div className={styles.earnPointsTag}>
                                        <div className={styles.earnTxt}>
                                            Earn
                                        </div>
                                        <div className={styles.pointsOnSale}>
                                            {item?.pointsOnSale}
                                        </div>
                                        <div className={styles.rewardTxt} >
                                            Reward Points
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.productThumbnail}>
                                    <img
                                        src={item?.productThumbnail}
                                        alt={`Product ${index + 1}`}
                                    />
                                </div>
                                <h4>{item?.productTitle}</h4>
                                <p>₹{item?.mrp}</p>
                            </Link>
                        ))}
                </div>
            </section>

            <AboutRewardPoints />

            {/* Features Section */}
            <section className={styles.featuresSection}>
                {loading ? (
                    <Skeleton height={100} count={3} style={{ marginBottom: '10px' }} />
                ) : (
                    <div className={styles.featuresContainer}>
                        <div className={styles.featureCard}>
                            <AiOutlineGift size={50} className={styles.featureIcon} />
                            <h3>Exclusive Deals</h3>
                            <p>Unlock special offers tailored for your business.</p>
                        </div>
                        <div className={styles.featureCard}>
                            <MdLoyalty size={50} className={styles.featureIcon} />
                            <h3>Loyalty Rewards</h3>
                            <p>Earn points and rewards with every purchase.</p>
                        </div>
                        <div className={styles.featureCard}>
                            <AiOutlineStar size={50} className={styles.featureIcon} />
                            <h3>Top-rated Suppliers</h3>
                            <p>Collaborate with trusted and highly rated businesses.</p>
                        </div>
                    </div>
                )}
            </section>

            {/* Call-to-action Section */}
            <section className={styles.ctaSection}>
                {loading ? (
                    <Skeleton height={150} />
                ) : (
                    <div className={styles.ctaContainer}>
                        <h2>Start Growing Your Business Today</h2>
                        <button className={styles.ctaButton} onClick={() => (window.location.href = '/signup')}>
                            Get Started
                        </button>
                    </div>
                )}
            </section>

        </div>
    );
};

export default Home;
